import { useState } from "react";
import { Box, Flex, Text, Button, Image } from "@chakra-ui/react";
import { IoMdClose } from "react-icons/io";
import LogoIcon from "../assets/images/logoIcon.png";

const IOS_STORE_URL =
  "https://apps.apple.com/us/app/book-d-find-beauty-pros/id6558535790";
const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bookd.customer";

interface Props {
  deepLink: string;
  isIOS: boolean;
}

export const OpenInAppBanner = ({ deepLink, isIOS }: Props) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const storeUrl = isIOS ? IOS_STORE_URL : ANDROID_STORE_URL;

  const handleOpenInApp = () => {
    window.location.href = deepLink;
    // If the app isn't installed the browser stays put, so after 1.5s send to the store
    setTimeout(() => {
      window.location.href = storeUrl;
    }, 1500);
  };

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="white"
      boxShadow="0px -4px 20px rgba(0, 0, 0, 0.12)"
      px="20px"
      py="14px"
      zIndex={1000}
      borderTop="1px solid #F0F0F0"
    >
      <Flex align="center" gap="12px">
        <Image src={LogoIcon} h="34px" w="20px" flexShrink={0} />

        <Box flex={1} minW={0}>
          <Text
            fontSize="14px"
            fontWeight={700}
            color="#19202D"
            fontFamily="RedHatDisplay-Bold"
            lineHeight="1.3"
          >
            Book-d
          </Text>
          <Text fontSize="12px" color="#4F4F51" lineHeight="1.4" noOfLines={1}>
            Continue this action in the Book-d app
          </Text>
        </Box>

        <Button
          bg="#FF8E3C"
          color="white"
          borderRadius="20px"
          h="36px"
          px="18px"
          fontSize="13px"
          fontFamily="RedHatDisplay-Bold"
          _hover={{ bg: "#e07a30" }}
          flexShrink={0}
          onClick={handleOpenInApp}
        >
          Open App
        </Button>

        <IoMdClose
          size={20}
          color="#9BA3A3"
          cursor="pointer"
          onClick={() => setDismissed(true)}
          style={{ flexShrink: 0 }}
        />
      </Flex>
    </Box>
  );
};
